/**
 * Render the final JSX of TeachingPopoverTrigger
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderTeachingPopoverTrigger_unstable", {
    enumerable: true,
    get: function() {
        return renderTeachingPopoverTrigger_unstable;
    }
});
const renderTeachingPopoverTrigger_unstable = (state)=>{
    return state.children;
};
